import React, { useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import Overlay from './overlay';
import { Navbar } from '../navbar';
import DraggableObserver from './draggable-observer';
import constants from './constants';
import helpers from './helpers';
import noop from '../utils/noop';

const { DRAGGABLE_BORDER_WIDTH } = constants;

const defaultTopbarHeight = Navbar.getHeight();

function FocalPoint({
  onOverlayClick = noop,
  onOverlayDoubleClick = noop,
  onDrag,
  onDragStart,
  onDragEnd,
  targetElementBounds,
  elementComputedStyles,
  controls,
  children = null,
  tooltipText = null,
  topbarHeight = defaultTopbarHeight,
}) {
  const { borderRadiusAxisX, borderRadiusAxisY } = useMemo(
    () =>
      helpers.getBorderRadius(
        elementComputedStyles,
        targetElementBounds.width,
        targetElementBounds.height
      ),
    [elementComputedStyles, targetElementBounds]
  );

  return (
    <Fragment>
      <div
        className="ws-focal-point-topbar-overlay"
        style={{ height: topbarHeight }}
        onClick={onOverlayClick}
        onDoubleClick={onOverlayDoubleClick}
      />
      <div className="ws-focal-point">
        {children}
        <Overlay
          onOverLayClick={onOverlayClick}
          elementBounds={targetElementBounds}
          borderRadius={{
            borderRadiusAxisX,
            borderRadiusAxisY,
          }}
        />
        {controls}
        <DraggableObserver
          targetElementBounds={targetElementBounds}
          borderWidth={DRAGGABLE_BORDER_WIDTH}
          borderRadius={{
            borderRadiusAxisX,
            borderRadiusAxisY,
          }}
          onChange={onDrag}
          onAfterChange={onDragEnd}
          onBeforeChange={onDragStart}
          onDoubleClick={onOverlayDoubleClick}
          onOverLayClick={onOverlayClick}
          tooltipText={tooltipText}
        />
      </div>
    </Fragment>
  );
}

FocalPoint.propTypes = {
  onOverlayClick: PropTypes.func,
  onOverlayDoubleClick: PropTypes.func,
  onDrag: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  tooltipText: PropTypes.string,
  elementComputedStyles: PropTypes.shape({}).isRequired,
  targetElementBounds: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    right: PropTypes.number,
    left: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  children: PropTypes.node,
  controls: PropTypes.element.isRequired,
  topbarHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FocalPoint;
